import React from "react";

import PropTypes from "prop-types";

import { Input } from "@ps-design-system/components/Input";
import { Text } from "@ps-design-system/components/Text";

import displayError from "../../app-main/components/reduxForms/utilities/displayError";

import { TAX_INFORMATION_TYPES } from "./tax-information.constants";
import { getTaxInformationMetaById } from "./tax-information.utils";

const TaxInformationInput = ({
  onChange,
  value,
  taxInformationId,
  ...props
}) => {
  const { format } = getTaxInformationMetaById(taxInformationId);

  return (
    <Input
      type="text"
      placeholder={format}
      onChange={onChange}
      value={value}
      {...props}
    />
  );
};

const TaxInformationInputField = ({
  input = {},
  meta = {},
  attributes = {},
  error,
  setError,
  taxInformationId,
  style,
}) => {
  const showError = (meta?.error && meta?.submitFailed) || error;

  const handleChange = (...args) => {
    setError(null);
    input.onChange(...args);
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <TaxInformationInput
        {...input}
        taxInformationId={taxInformationId}
        style={style}
        onChange={handleChange}
        {...attributes}
      />
      {showError && (
        <Text typeface="caption-2" className="tw-text-red-700">
          {displayError(error, meta?.error)}
        </Text>
      )}
    </div>
  );
};

TaxInformationInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  style: PropTypes.object,
  taxInformationId: PropTypes.oneOf(Object.values(TAX_INFORMATION_TYPES)),
};

TaxInformationInputField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  attributes: PropTypes.object,
  error: PropTypes.string,
  setError: PropTypes.func,
  style: PropTypes.object,
  taxInformationId: PropTypes.oneOf(Object.values(TAX_INFORMATION_TYPES)),
};

export { TaxInformationInput, TaxInformationInputField };
